export default __webpack_public_path__ + "static/media/five-oclock-img.b2db8a71.png";